import request from '@/utils/request'
class parent {
    // /pushRecord/queryAllPushRecordInfo/{ztid}
    cxxx(ztid) {
        return request({
            url: `/pushRecord/queryAllPushRecordInfo/${ztid}`,
            method: 'get'
        })
    }
    ///pushRecord/queryAllPushRecordInfo管理员推送信息
    queryAllPushRecordInfo(data) {
        return request({
            url: `/pushRecord/queryAllPushRecordInfo`,
            method: 'post',
            data
        })
    }
    ///pushRecord/queryPushRecordInfoByZtid普通管理员推送信息
    queryPushRecordInfoByZtid(data) {
        return request({
            url: `/pushRecord/queryPushRecordInfoByZtid`,
            method: 'post',
            data
        })
    }
	queryPushRecordInfoByZtid1(data) {
	    return request({
	        url: `/pushRecord/queryPushRecordInfoByZtid1`,
	        method: 'post',
	        data
	    })
	}
}
let item = new parent()

export default item